module.exports = __webpack_public_path__ + "img/bottom-right-background.b455b18d.svg";